
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'MobileContainer',
  props: {
    spaceHeader: { type: String, default: '0' },
    spaceFooter: { type: String, default: '0' }
  },
  setup(props) {
    const style = computed(
      () => `padding-top: ${props.spaceHeader}; padding-bottom: ${props.spaceFooter}`
    )
    return {
      style
    }
  }
})
